<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"courseleg",

        data(){
            return {
            }
        },

        computed:{
            geoJSON:function(){
                return this.$store.getters.currentCourseLeg;
            },
        },


        watch:{
            geoJSON:function(){
                this.animateLine(3, true)
            }
        },

        methods:{

        },
        
        style: function () {
            return {
                "id": "percurso",
                "type": "line",
                // "source": "percurso",
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    "line-dasharray": {
                        "base": 1,
                        "stops": [
                            [11, [4, 0]],
                            [12, [3, 2]]
                        ]
                    },
                    "line-color": {
                        "base": 1,
                        "stops": [
                            [9, '#333333'],
                            [11, '#33fe12']
                        ]
                    },
                    "line-width": {
                        "base": 1,
                        "stops": [
                            [9, 0.8],
                            [11, 3]
                        ]
                    },
                    "line-opacity": {
                        "base": 1,
                        "stops": [
                            [9, 0.2],
                            [11, 1]
                        ]
                    },
                }
            }
        }

    }


</script>